import React, { useEffect, useState } from 'react';
import './style.css';
import { useSearchParams } from 'react-router-dom';

function StaticClientForm() {
  const [searchParams, setSearchParams] = useSearchParams();
  const restaurantId = Number(searchParams.get('restaurantId'));
  
  return (
    <div className='form-container' id={`bamboo-reserve-form-${restaurantId}`}>
      
    </div>
    
  );
}
export default StaticClientForm;